'use strict';

var AssignRoleDirective = function AssignRoleDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/assign-role.html'),
    controller: 'AssignRoleController',
    scope: {
      newRole: '='
    },
    link: function link($scope, element) {
      element.on('show.bs.modal', function () {
        $scope.$broadcast('grid:loadData:' + $scope.gridId);
      });
      $scope.hideModal = function () {
        element.modal('hide');
      };
    }
  };
};
AssignRoleDirective.$inject = [];
module.exports = AssignRoleDirective;